import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

import { hasApplicationWithProductType } from './lendingAPI/ApplicationSelector';
import {
    getAllAccounts,
    IWOCAPAY_PRODUCT_TYPE
} from '../myAccount/multiLoanDashboard/accountsSelector';

export const isIwocaPayCustomer = (state: RootState) => {
    const iwocaPayAccount = getLatestIwocapayAccount(state);
    const nonIwocaPayAccounts = getNonIwocaPayAccounts(state);
    const hasIwocaPayRequestedProduct = hasIwocaPayApplication(state);

    if (iwocaPayAccount) {
        if (
            _.get(iwocaPayAccount, 'loan_status') === 'ended' &&
            !hasIwocaPayRequestedProduct
        ) {
            return false;
        }

        return true;
    }

    if (getLatestIwocaPayFormalOffer(state)) {
        return true;
    }

    if (hasIwocaPayRequestedProduct && !nonIwocaPayAccounts.length) {
        return true;
    }

    return false;
};

export const isIwocaPaySeller = ({ siteContext }: RootState) =>
    siteContext.is_iwocapay_seller;

const getIwocaPayAccounts = (state: RootState) => {
    return _.filter(
        getAllAccounts(state),
        (account) => account.product_type === IWOCAPAY_PRODUCT_TYPE
    );
};

const getLatestIwocapayAccount = (state: RootState) =>
    getIwocaPayAccounts(state)[0];

const getNonIwocaPayAccounts = (state: RootState) => {
    return _.filter(
        getAllAccounts(state),
        (account) => account.product_type !== IWOCAPAY_PRODUCT_TYPE
    );
};

const getLatestIwocaPayFormalOffer = (state: RootState) => {
    return _.get(
        _.find(
            getAllAccounts(state),
            (account) =>
                _.get(account, 'latest_formal_offer.product_type') ===
                IWOCAPAY_PRODUCT_TYPE
        ),
        'latest_formal_offer'
    );
};

const hasIwocaPayApplication = (state: RootState) => {
    return hasApplicationWithProductType(state, IWOCAPAY_PRODUCT_TYPE);
};
